import {createRoot} from 'react-dom/client';
import {StrictMode} from "react";
import FooterPopup from "../components/footer_popup/FooterPopup";

document.addEventListener('DOMContentLoaded', function () {
    const nodePopup = document.getElementById('js-initial-popup');
    if (nodePopup) {
        const popup = createRoot(nodePopup)
        popup.render(
            <StrictMode>
                <FooterPopup/>
            </StrictMode>
        )
    }
})
